import { Directive, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[rsNumericControl]'
})
export class NumericControlDirective implements OnInit {

  @Input() onlyInt: boolean;

  private allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

  ngOnInit() {
    if (!this.onlyInt) {
      this.allowedKeys.push('.');
    }
  }

  @HostListener('keydown', ['$event'])
  inputHandler(event: KeyboardEvent): void {
    const value = Number(event.key);

    if (value !== value && !this.allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

}
